import acnh1 from '../../../../assets/images/jumbo/acnh1.jpg';
import acnh2 from '../../../../assets/images/jumbo/acnh2.jpg';
import acnh3 from '../../../../assets/images/jumbo/acnh3.jpg';
import atomic from '../../../../assets/images/jumbo/atomic.jpg';
import botw1 from '../../../../assets/images/jumbo/botw1.jpg';
import botw2 from '../../../../assets/images/jumbo/botw2.jpg';
import broforce from '../../../../assets/images/jumbo/broforce.jpg';
import cadHyrule from '../../../../assets/images/jumbo/cadHyrule.jpg';
import celeste1 from '../../../../assets/images/jumbo/celeste1.jpg';
import celeste2 from '../../../../assets/images/jumbo/celeste2.jpg';
import childrenMorta from '../../../../assets/images/jumbo/childrenMorta.jpg';
import civ from '../../../../assets/images/jumbo/civ.jpg';
import crossing1 from '../../../../assets/images/jumbo/crossing1.jpg';
import crossing2 from '../../../../assets/images/jumbo/crossing2.jpg';
import deadCells from '../../../../assets/images/jumbo/deadCells.jpg';
import diablo from '../../../../assets/images/jumbo/diablo.jpg';
import dQ from '../../../../assets/images/jumbo/dQ.jpg';
import elden from '../../../../assets/images/jumbo/elden.jpg';
import escapist from '../../../../assets/images/jumbo/escapist.jpg';
import evoland from '../../../../assets/images/jumbo/evoland.jpg';
import fez from '../../../../assets/images/jumbo/fez.jpg';
import gaia from '../../../../assets/images/jumbo/gaia.jpg';
import gungeon1 from '../../../../assets/images/jumbo/gungeon1.jpg';
import gungeon2 from '../../../../assets/images/jumbo/gungeon2.jpg';
import hades1 from '../../../../assets/images/jumbo/hades1.jpg';
import hades2 from '../../../../assets/images/jumbo/hades2.jpg';
import halo from '../../../../assets/images/jumbo/halo.jpg';
import hld from '../../../../assets/images/jumbo/hld.jpg';
import hollow from '../../../../assets/images/jumbo/hollow.jpg';
import hue from '../../../../assets/images/jumbo/hue.jpg';
import humans from '../../../../assets/images/jumbo/humans.jpg';
import inside from '../../../../assets/images/jumbo/inside.jpg';
import katana from '../../../../assets/images/jumbo/katana.jpg';
import legoHarry1 from '../../../../assets/images/jumbo/legoHarry1.jpg';
import legoHarry2 from '../../../../assets/images/jumbo/legoHarry2.jpg';
import legoHarry3 from '../../../../assets/images/jumbo/legoHarry3.jpg';
import lozla from '../../../../assets/images/jumbo/lozla.jpg';
import mario from '../../../../assets/images/jumbo/mario.jpg';
import marioGolf1 from '../../../../assets/images/jumbo/marioGolf1.jpg';
import marioGolf2 from '../../../../assets/images/jumbo/marioGolf2.jpg';
import md from '../../../../assets/images/jumbo/md.jpg';
import mh1 from '../../../../assets/images/jumbo/mh1.jpg';
import mh2 from '../../../../assets/images/jumbo/mh2.jpg';
import ofdp from '../../../../assets/images/jumbo/ofdp.jpg';
import ori1 from '../../../../assets/images/jumbo/ori1.jpg';
import ori2 from '../../../../assets/images/jumbo/ori2.jpg';
import party from '../../../../assets/images/jumbo/party.jpg';
import phogs from '../../../../assets/images/jumbo/phogs.jpg';
import podRacer1 from '../../../../assets/images/jumbo/podRacer1.jpg';
import podRacer2 from '../../../../assets/images/jumbo/podRacer2.jpg';
import pokeArc from '../../../../assets/images/jumbo/pokeArc.jpg';
import pokemon from '../../../../assets/images/jumbo/pokemon.jpg';
import pokemon2 from '../../../../assets/images/jumbo/pokemon2.jpg';
import rocket from '../../../../assets/images/jumbo/rocket.jpg';
import smrpg from '../../../../assets/images/jumbo/smrpg.jpg';
import smrpg2 from '../../../../assets/images/jumbo/smrpg2.jpg';
import spfbw from '../../../../assets/images/jumbo/spfbw.jpg';
import spirit1 from '../../../../assets/images/jumbo/spirit1.jpg';
import spirit2 from '../../../../assets/images/jumbo/spirit2.jpg';
import ssbu from '../../../../assets/images/jumbo/ssbu.jpg';
import takes2 from '../../../../assets/images/jumbo/takes2.jpg';
import terraria from '../../../../assets/images/jumbo/terraria.jpg';
import valfaris from '../../../../assets/images/jumbo/valfaris.jpg';
import vampire from '../../../../assets/images/jumbo/vampire.jpg';
import whatGolf from '../../../../assets/images/jumbo/whatGolf.jpg';
import worms from '../../../../assets/images/jumbo/worms.jpg';
import wow from '../../../../assets/images/jumbo/wow.jpg';

const JUMBOIMAGES = [
    acnh1,
    acnh2,
    acnh3,
    atomic,
    botw1,
    botw2,
    broforce,
    cadHyrule,
    celeste1,
    celeste2,
    childrenMorta,
    civ,
    crossing1,
    crossing2,
    deadCells,
    diablo,
    dQ,
    elden,
    escapist,
    evoland,
    fez,
    gaia,
    gungeon1,
    gungeon2,
    hades1,
    hades2,
    halo,
    hld,
    hollow,
    hue,
    humans,
    inside,
    katana,
    legoHarry1,
    legoHarry2,
    legoHarry3,
    lozla,
    mario,
    marioGolf1,
    marioGolf2,
    md,
    mh1,
    mh2,
    ofdp,
    ori1,
    ori2,
    party,
    phogs,
    podRacer1,
    podRacer2,
    pokeArc,
    pokemon,
    pokemon2,
    rocket,
    smrpg,
    smrpg2,
    spfbw,
    spirit1,
    spirit2,
    ssbu,
    takes2,
    terraria,
    valfaris,
    vampire,
    whatGolf,
    worms,
    wow
];

export default JUMBOIMAGES;